import Api from '@/services/Api'

export default {

  // Método que llama a la url para crear un chat
  getPatientOftalmos () {
    return Api().get("/patient-oftalmos");
  },
  updatePatientOftalmo (params) {
    return Api().put("/patient-oftalmos",params);
  },
  addPatientOftalmo (params) {
    return Api().post("/patient-oftalmos",params);
  },
  getPatientOfatlmo (params) {
    return Api().get("/patient-oftalmos/"+params);
  },
  deletePatientOftalmo (params) {
    return Api().delete("/patient-oftalmos/"+params);
  },
  getPatientOfatlmoByRouteSheets(params){
    return Api().get("/patient-oftalmos-route-sheet/"+params);
  },

}



// WEBPACK FOOTER //
// ./src/services/PatientOftalmoService.js